// extracted by mini-css-extract-plugin
export var compactFilters = "_ei-4";
export var detailImage = "_ei-1";
export var dropdownContainer = "_ei-2";
export var imageContainer = "_ei-0";
export var selectedCard = "_ei-3";